var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSequenceLoopImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000006083"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 5013",
    d: "M8.75 1C12.2018 1 15 3.91015 15 7.5C15 11.0899 12.2018 14 8.75 14C5.29822 14 2.5 11.0899 2.5 7.5C2.5 5.37372 3.48168 3.4859 4.99939 2.3M4.99939 2.3V6M4.99939 2.3L1 3",
    stroke: "#1F1CD7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000006082"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1194",
    d: "M8.75 5V10.5",
    stroke: "#1F1CD7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1195",
    d: "M11.5 7.75L6 7.75",
    stroke: "#1F1CD7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSequenceLoopImg);
export default __webpack_public_path__ + "static/media/sequence-loop-img.3a0f22e0640120b7265bf34724771095.svg";
export { ForwardRef as ReactComponent };